import { i18n } from '@lt/localization';
import type { CSSObjectWithLabel } from 'react-select';
import type { CommunicationTimeType } from './types';

export const communicationTime: CommunicationTimeType[] = [
  {
    value: i18n.t('hotel.expensiveHotelForm.communicationTime.first'),
    label: i18n.t('hotel.expensiveHotelForm.communicationTime.first'),
  },
  {
    value: i18n.t('hotel.expensiveHotelForm.communicationTime.second'),
    label: i18n.t('hotel.expensiveHotelForm.communicationTime.second'),
  },
  {
    value: i18n.t('hotel.expensiveHotelForm.communicationTime.third'),
    label: i18n.t('hotel.expensiveHotelForm.communicationTime.third'),
  },
  {
    value: i18n.t('hotel.expensiveHotelForm.communicationTime.fourth'),
    label: i18n.t('hotel.expensiveHotelForm.communicationTime.fourth'),
  },
  {
    value: i18n.t('hotel.expensiveHotelForm.communicationTime.fifth'),
    label: i18n.t('hotel.expensiveHotelForm.communicationTime.fifth'),
  },
];

export const getStyles = (): CSSObjectWithLabel => ({
  fontSize: 15,
  fontWeight: 400,
  lineHeight: 1.75,
});

export const COUNT_OPEN_EXPENSIVE_HOTEL_PAGE =
  'COUNT_OPEN_EXPENSIVE_HOTEL_PAGE';

export const EXPENSIVE_HOTEL_POPUP_TEST_ID = 'EXPENSIVE_HOTEL_POPUP_TEST_ID';
export const EXPENSIVE_HOTEL_MOBILE_POPUP_TEST_ID =
  'EXPENSIVE_HOTEL_MOBILE_POPUP_TEST_ID';
export const EXPENSIVE_HOTEL_FORM_TEST_ID = 'EXPENSIVE_HOTEL_FORM_TEST_ID';
export const EXPENSIVE_HOTEL_FORM_ERROR_TEST_ID =
  'EXPENSIVE_HOTEL_FORM_ERROR_TEST_ID';
export const EXPENSIVE_HOTEL_FORM_SEND_BUTTON_TEST_ID =
  'EXPENSIVE_HOTEL_FORM_SEND_BUTTON_TEST_ID';

export const EXPENSIVE_HOTEL_SENDED_FORM_TEST_ID =
  'EXPENSIVE_HOTEL_SENDED_FORM_TEST_ID';
export const EXPENSIVE_HOTEL_FORM_CLOSE_BUTTON_TEST_ID =
  'EXPENSIVE_HOTEL_FORM_CLOSE_BUTTON_TEST_ID';
